import Model from "~/models/_Model";
import System from "./System";
import Task from "./Task";
import dayjs from "dayjs";

export default class Log extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/systemsmanager";
  }

  // Set the resource route of the model
  resource() {
    return "logs";
  }

  relations() {
    return {
      system: System,
      task: Task,
    };
  }

  get display_status_color() {
    switch (this.log_type) {
      case 1:
        return "info";
      case 2:
        return "positive";
      case 3:
        return "warning";
      case 4:
        return "negative";
      default:
        return "default";
    }
  }

  get display_timestamp() {
    if (!this.timestamp) {
      return "";
    }
    return dayjs(this.timestamp).format("MM/DD/YYYY @ h:mm:ss A");
  }
}
